import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import learnMoreClick from 'commons/learnMoreClick';
import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import useUserData from 'data-hooks/useUserData';
import useAffirmRefreshHTML from 'hooks/useAffirmRefreshHTML';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPFinancingUI from './PDPFinancingUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
const PDPFinancing = ({
  loading
}) => {
  const {
    isTradeUser
  } = useUserData();
  // User state comes from localStorage, so the server always renders the
  // financing row. Hide it for trade users only after mount so the hydration
  // render matches the server HTML.
  const isBrowser = useIsBrowser();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading: priceLoading,
    priceDetails
  } = usePDPTieredPrice();
  const affirmButtonRef = useRef();
  const [isFinancingModalLoading, setIsFinancingModalLoading] = useState(false);
  useAffirmRefreshHTML(affirmButtonRef, {
    deferLoad: true,
    eagerLearnMore: true
  });
  const price = !priceDetails?.hasDiscount ? priceDetails?.priceWithOptionsPrice : priceDetails?.hasTieredDiscount ? priceDetails?.maxTieredDiscountedPrice : priceDetails?.salePriceWithOptionsPrice;
  const numberOfMonths = price <= 1499 ? 12 : 18;
  const perMonthAmount = Math.round(price / numberOfMonths);
  const isLoading = loading || priceLoading;
  const handleFinancingClick = useCallback(async () => {
    setIsFinancingModalLoading(true);
    try {
      await learnMoreClick(affirmButtonRef);
    } finally {
      setIsFinancingModalLoading(false);
    }
  }, []);
  if (isBrowser && isTradeUser) {
    return null;
  }
  return priceLoading ? null : <PDPFinancingUI loading={isLoading} affirmButtonRef={affirmButtonRef} isFinancingModalLoading={isFinancingModalLoading} numberOfMonths={numberOfMonths} onFinancingClick={handleFinancingClick} pdpIsModularBYOProduct={pdpIsModularBYOProduct} perMonthAmount={perMonthAmount} price={price} />;
};
PDPFinancing.propTypes = {
  loading: PropTypes.bool
};
export default PDPFinancing;